import { render } from "./Gearbox.vue?vue&type=template&id=ca55b9e4"
import script from "./Gearbox.vue?vue&type=script&lang=js"
export * from "./Gearbox.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__